var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 90.455A40.455 40.455 0 1 1 90.455 50 40.5 40.5 0 0 1 50 90.455Zm0-77.91A37.455 37.455 0 1 0 87.455 50 37.5 37.5 0 0 0 50 12.545Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.05 65.352a1.5 1.5 0 0 1-1.061-.439l-11.8-11.8a1.5 1.5 0 0 1 2.121-2.121l10.74 10.739 26.644-26.644a1.5 1.5 0 1 1 2.121 2.121L43.11 64.913a1.493 1.493 0 0 1-1.06.439Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBig);
export default __webpack_public_path__ + "static/media/check-big.4870bd25ef4c48ae4643765a7797034b.svg";
export { ForwardRef as ReactComponent };